import { useEffect, useState } from "react";
import { PlantStore } from "./PlantStore";

export function usePlantStore() {
  const [state, setState] = useState(PlantStore.get());

  useEffect(() => {
    return PlantStore.subscribe(setState);
  }, []);

  return state;
}